import React from "react";
import {useQueryClient} from "react-query";
import ProgressBar from "../../../controls/ProgressBar";
import useFlightsCapacityUtilization from "../../../services/flights/useFlightsCapacityUtilization";

const barColors = {
  green: "rgba(0, 128, 0, 1)",
  red: "rgba(255, 0, 0, 1)",
  orange: "rgba(255, 128, 0, 1)",
  purple: "rgba(128, 0, 128, 1)",
}

const CustomerAllotmentBar = (_props) => {

  const props = {
    canEdit: true,
    ..._props
  }

  const tripLegUuid = props.tripLegUuid;
  const companyUuid = props.companyUuid;
  const customerAllotment = props.customerAllotment;

  const extraKeys = [tripLegUuid,companyUuid];
  const queryClient = useQueryClient();
  const customerBookings = useFlightsCapacityUtilization({queryClient, extraKeys});

  const completed = customerBookings.data ? (customerBookings.data.totalChargeableWeight && !isNaN(customerBookings.data.totalChargeableWeight) && customerBookings.data.allotmentKg && customerBookings.data.allotmentKg > 0 ? customerBookings.data.totalChargeableWeight / customerBookings.data.allotmentKg * 100 : 0) : 0;

  return(
    <ProgressBar completed={Number(completed).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1})} backgroundColor={completed > 100 ? barColors.purple : completed < 50 ? barColors.red : completed < 75 ? barColors.orange : barColors.green}/>
  );
}

export default CustomerAllotmentBar;
